import { AnagraficaUtenteDisponibilitaOrarioDto } from "./anagrafica.models";
import { ComuniDto } from "./comuni.models";
import { MansioniDto } from "./lavoro.models";
import { SharedEnumModelKeyValue } from "./shared.models";

export class AnagraficaUtenteLavoroDesideratoDto{
  public IdAnagraficaUtenteLavoroDesiderato : number = 0;
  public IdAnagraficaUtente : number = 0;
  public IdMansione : number = 0;
  public MansioneDesc : string = "";
  public IdMansionePadre : number = 0;
  public MansioneDescPadre : string = "";
}

export class CorsoFormazioneDto {
  public IdCorso : number = 0;
  public CorsoDesc : string = "";
}


export class ProfiloPreferenze{
  public IdAnagraficaUtente : number = 0;
  public IdMansioneList : string = "";
  public DisponibilitaOrarioList : string = '';
  public DisponibilitaFrequentareCorsi : boolean = true;
  public CorsiFormazione : string = '';
  public DisponibilitaPolitcheAttive : boolean = true;
  public CategoriaProtetta : boolean = true;
  public PatenteA : boolean = true;
  public PatenteB : boolean = true;
  public PatenteC : boolean = true;
  public PatenteD : boolean = true;
  public PatenteE : boolean = true;
  public Automunito : boolean = true;

}

export class CCNLSettore{
  public IdCCNLSettore : number = 0;
  public Settore : string = "";
}


